module.exports = __webpack_public_path__ + "static/media/15-jose-leite-juca.80f9d5e9.webp";